<script>
  import { ArrowUpRight, ArrowDownLeft } from '../lib/icons/index.js';
  import { directionLabel } from '../lib/labels.js';

  // Direction badge with icon + Italian word ("Emessa" / "Ricevuta"), so the
  // meaning never rides on colour or an arrow alone.
  export let direction = '';
  $: out = direction === 'outbound';
</script>

<span class="badge {out ? 'badge-cyan' : 'badge-magenta'} gap-1">
  {#if out}
    <ArrowUpRight size={12} />
  {:else}
    <ArrowDownLeft size={12} />
  {/if}
  {directionLabel(direction)}
</span>
